// we write all api calls here

import { endpoints } from "@app/api/apis";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";


export const getLastMismatchResponse = async (payload: {
  applicationId: string;
}) => {

  let applicationId = payload.applicationId;
  let applicationIdStored = await AsyncStorage.getItem('application_id')

  if (applicationIdStored) {
    applicationId = applicationIdStored;
  }
  const response = await axios.get(endpoints.nameMismatchResponse + applicationId);
  return response.data;
}
